import Price from '@allesauto/core/price';
import translate from '@allesauto/i18n';
import Link from 'next/link';
import { useIntl } from 'react-intl';

export interface FilterBoxListProps {
  price: number;
  offersAmount: number;
  isLastItem: boolean;
  searchUrl: string;
}

export default function FilterBoxList({
  price,
  offersAmount,
  isLastItem,
  searchUrl,
}: FilterBoxListProps) {
  const intl = useIntl();

  const classNames = {
    container: `flex flex-col justify-center items-center no-underline w-auto bg-white border-1px min-h-[130px] rounded-default border-grey30 hover:border-purple80`,
    color: 'text-purple80',
    mainPriceClass: 'text-headline4',
  };

  return (
    <Link href={searchUrl ?? '/'} className={classNames.container}>
      <div className={classNames.color}>
        <Price
          price={price}
          classNames={{ mainPriceClass: classNames.mainPriceClass }}
          priceTextKey={isLastItem ? 'ui.PRICE.TEXT' : 'ui.PRICE.UNTIL'}
          hasFractionDigits
          isTeaserPrice
        />
      </div>
      <div className={classNames.color}>
        {Intl.NumberFormat().format(offersAmount).replace(',', '.')}{' '}
        {translate(intl, 'ui.FILTER_PAGE.OFFERS')}
      </div>
    </Link>
  );
}
